export default __webpack_public_path__ + "static/media/ic_home_active_TP.3f51bb3d.svg";